import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1039784d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-1" }
const _hoisted_3 = { class: "p-mx-1" }
const _hoisted_4 = { class: "p-mx-1" }
const _hoisted_5 = { class: "p-grid p-text-center p-m-0 style-grid" }
const _hoisted_6 = { class: "p-col" }
const _hoisted_7 = { class: "p-mx-2" }
const _hoisted_8 = { class: "p-mx-2" }
const _hoisted_9 = { class: "p-mx-2" }
const _hoisted_10 = { class: "p-mx-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_12 = { class: "p-buttonset" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-times",
              label: "Clear All",
              class: "p-button-danger",
              onClick: _ctx.clearAll
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              label: "Add Row",
              class: "p-button-success",
              onClick: _ctx.addNewRow
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              icon: "pi pi-check",
              label: "Save Stock",
              class: "p-button-success",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveFileData()))
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("b", _hoisted_7, " TOTAL ITEMS : " + _toDisplayString(_ctx.totalItems), 1),
          _createElementVNode("b", _hoisted_8, " VALID ITEMS : " + _toDisplayString(_ctx.totalValid), 1),
          _createElementVNode("b", _hoisted_9, " INVALID ITEMS : " + _toDisplayString(_ctx.totalInValid), 1),
          _createElementVNode("b", _hoisted_10, " STOCK WORTH AMT : " + _toDisplayString(_ctx.stockWorth), 1)
        ])
      ]),
      _createVNode(_component_DataTable, {
        value: _ctx.excelFileContent,
        responsiveLayout: "scroll",
        class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
      }, {
        empty: _withCtx(() => [
          _hoisted_11
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, null, {
            body: _withCtx((slotProps) => [
              _createElementVNode("i", {
                class: _normalizeClass([this.validateStock.includes(_ctx.excelFileContent.indexOf(slotProps.data)) ? 'row-invalid' : 'row-valid', "pi pi-check-circle p-p-2"])
              }, null, 2)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Product Name*" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                modelValue: slotProps.data.productName,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.productName) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Generic Name*" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                modelValue: slotProps.data.genericName,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.genericName) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Common Name" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                modelValue: slotProps.data.productName,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.productName) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Reference" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                style: {"width":"80px"},
                modelValue: slotProps.data.barcode,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.barcode) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Barcode" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                style: {"width":"80px"},
                modelValue: slotProps.data.barcode,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.barcode) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Unit Name" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                style: {"width":"50px"},
                modelValue: slotProps.data.barcode,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.barcode) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Unit Value" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                style: {"width":"80px"},
                modelValue: slotProps.data.barcode,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.barcode) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Prescription Required" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                style: {"width":"80px"},
                modelValue: slotProps.data.barcode,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.barcode) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Product Type*" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Dropdown, {
                id: "type",
                modelValue: slotProps.data.productType,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.productType) = $event),
                options: _ctx.productType,
                optionLabel: "option_name",
                optionValue: "id",
                filter: "",
                filterPlaceholder: "Search product type"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Brand Name*" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Dropdown, {
                id: "type",
                modelValue: slotProps.data.brandName,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.brandName) = $event),
                options: _ctx.brand,
                optionLabel: "option_name",
                optionValue: "id",
                filter: "",
                filterPlaceholder: "Search brand"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Brand Sector*" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Dropdown, {
                id: "type",
                modelValue: slotProps.data.brandSector,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.brandSector) = $event),
                options: _ctx.brandSector,
                optionLabel: "option_name",
                optionValue: "id",
                filter: "",
                filterPlaceholder: "Search brand sector"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Category*" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Dropdown, {
                id: "type",
                modelValue: slotProps.data.category,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.category) = $event),
                options: _ctx.category,
                optionLabel: "option_name",
                optionValue: "id",
                filter: "",
                filterPlaceholder: "Search category"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Side Effects" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                modelValue: slotProps.data.sideEffects,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.sideEffects) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Description" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_InputText, {
                modelValue: slotProps.data.description,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.description) = $event),
                class: "p-p-1"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            exportable: false,
            header: "Action"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-rounded p-button-danger",
                  onClick: ($event: any) => (_ctx.clearListItem(slotProps.data))
                }, null, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ])
  ]))
}